import React from 'react'
import { assetPrefix } from 'src/config/env_config'
import * as S from './styles'

const icons = {
  info: `${assetPrefix}/static/icons/info-icon.svg`,
  danger: `${assetPrefix}/static/icons/danger-icon.svg`,
  warning: `${assetPrefix}/static/icons/warning-icon.svg`
}

const Alert = ({ type = 'info', show, children, textContent, margin, textTitle }) => {
  return (
    <>
      {show && (
        <S.AlertContainer margin={margin} type={type}>
          <S.Icon src={icons[type]} />
          <div>
            {textTitle && <S.Title>{textTitle}</S.Title>}
            {textContent && <p>{textContent}</p>}
          </div>
          <S.Message>{children}</S.Message>
        </S.AlertContainer>
      )}
    </>
  )
}

export default Alert
